import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_EXPORT_DOWNLOAD_SERVER } from '@/app/module/campaigns/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import download from '@/app/service/util/download'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useDownloadExport = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [downloading, setDownloading] = useState(false)

  const downloadFn = useCallback(
    async (exportId: number, filename: string) => {
      try {
        setDownloading(true)
        await download.exports(orgId, exportId, filename)
        return true
      } catch {
        dispatch(
          createNotification({
            'export-download-error': {
              type: 'error',
              message: ERROR_EXPORT_DOWNLOAD_SERVER,
            },
          }),
        )
        return false
      } finally {
        setDownloading(false)
      }
    },
    [orgId, dispatch],
  )

  return [downloadFn, { downloading }] as const
}
